export const unwrap = (response) => response.data?.data;
export const params = (values) => Object.fromEntries(Object.entries(values).filter(([, value]) => value !== "" && value !== undefined));
export const formatDate = (value, locale) => value ? new Intl.DateTimeFormat(locale, { dateStyle: "medium" }).format(new Date(value)) : "—";
